import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TracesUploadDocumentViewModel } from '../../../core/_infrastructure/types/web.services';
import { TipoDocumentacionViewModel } from '../../../_mantenimiento/general/tipodocumentacion/tipodocumentacion.types';
import { GenericPostDownloadPdfTracesRequest, SolicitudDocumentosViewModel, TDocumentoSolicitudViewModel } from './documentos.types';

//https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core

@Injectable()
export class DocumentosService {
    private fileEndpoint = this.baseUrl + 'api/core/file/';

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    //antes se trataba en global.service como una Tc pero ahora requiere recuperar otras columnas adicionales de BD
    getTipoDocumentacion(): Observable<TipoDocumentacionViewModel[]> {
        return (
            this.http
                //.get<TipoDocumentacionViewModel[]>(this.baseUrl + 'api/importacion/documentos/tipoDocumentacion').pipe();
                .get<TipoDocumentacionViewModel[]>(this.baseUrl + 'api/mantenimiento/tipodocumentacion/tiposdocumentacion')
                .pipe()
        );
    }

    //todos los documentos de una solicitud
    getSolicitudDocumentos(id: number): Observable<SolicitudDocumentosViewModel> {
        return this.http.get<SolicitudDocumentosViewModel>(this.baseUrl + 'api/importacion/documentos/' + id).pipe();
    }

    //obtener un documento concreto
    getDocumento(id: number): Observable<TDocumentoSolicitudViewModel> {
        return this.http.get<TDocumentoSolicitudViewModel>(this.baseUrl + 'api/importacion/documentos/documento/' + id).pipe();
    }

    //crear un documento, necesita IdSolicitud
    createDocumento(documento: TDocumentoSolicitudViewModel): Observable<TracesUploadDocumentViewModel> {
        return this.http.post<TracesUploadDocumentViewModel>(this.baseUrl + 'api/importacion/documentos', documento).pipe();
    }

    editDocumento(documento: TDocumentoSolicitudViewModel): Observable<TracesUploadDocumentViewModel> {
        return this.http.put<TracesUploadDocumentViewModel>(this.baseUrl + 'api/importacion/documentos', documento).pipe();
    }

    deleteDocumento(id: number): Observable<any> {
        return this.http.delete<TDocumentoSolicitudViewModel>(this.baseUrl + 'api/importacion/documentos/' + id).pipe();
    }

    uploadDocumentoTraces(id: number): Observable<TracesUploadDocumentViewModel> {
        return this.http.put<TracesUploadDocumentViewModel>(this.baseUrl + 'api/importacion/documentos/putUploadDocumentTraces', id).pipe();
    }

    downloadDocumentoTraces(nppoReferenceNumber: string, issuingNppoCountryId: string) {
        let request = new GenericPostDownloadPdfTracesRequest();

        request.Reference = nppoReferenceNumber;
        request.issuingNppoCountryID = issuingNppoCountryId;

        return this.http.post<any>(this.baseUrl + 'api/importacion/documentos/getDownloadPdfTraces', request).pipe();
    }

    deleteFile(guid: string): Observable<any> {
        return this.http.delete<string>(this.fileEndpoint + guid);
    }
}
